import { Buffer } from 'buffer';
window.Buffer = Buffer;
global.THREE = require("three");
const THREE = global.THREE;
const OrbitControls = require("three-orbit-controls")(THREE);
const loadFont = require("load-bmfont");
const createGeometry = require("three-bmfont-text");
const MSDFShader = require("three-bmfont-text/shaders/msdf");

// Font assets
const fontFile = require("./fonts/Lato-Black.fnt");
const fontAtlas = require("./fonts/Lato-Black.png");

// Nice colors
const colors = require("nice-color-palettes");
const palette = colors[4];
const background = "#ffffff";

export default class WebGLFont {
  constructor(opts = {}) {
    this.options = opts;
    this.canvas = document.getElementById("webgl");
    // console.log(this.canvas.width);

    // Variables
    this.vars = {
      word: this.options.word,
      position: [...this.options.position],
      rotation: [...this.options.rotation],
      zoom: this.options.zoom,
      vertex: this.options.vertex,
      fragment: this.options.fragment
    };

    // Scene
    this.scene = new THREE.Scene();

    // Camera
    this.camera = new THREE.PerspectiveCamera(
      75,
      this.canvas.width / this.canvas.height,
      0.1,
      1000
    );
    this.camera.position.z = this.vars.zoom;

    // Renderer
    this.renderer = new THREE.WebGLRenderer({
      canvas: this.canvas,
      antialias: true
    });
    this.renderer.setClearColor(background);
    this.renderer.setSize(this.canvas.width, this.canvas.height);
    this.renderer.setPixelRatio(this.canvas.devicePixelRatio);

    // Controls
    this.controls = new OrbitControls(this.camera, this.renderer.domElement);

    // Load resources and initialize
    this.loadResources().then(({geometry, texture}) => {
      this.init(geometry, texture);
      this.animate();
    }).catch(err => {
      console.error("Error loading resources:", err);
    });
  }

  loadResources() {
    return new Promise((resolve, reject) => {
      loadFont(fontFile, (err, font) => {
        if (err) {
          reject(err);
          return;
        }
        const geometry = createGeometry({
          font,
          text: this.vars.word,
          width: 400
        });

        const loader = new THREE.TextureLoader();
        loader.load(fontAtlas, texture => {
          resolve({ geometry, texture });
        }, undefined, reject);
      });
    });
  }

  init(geometry, texture) {
    let startTime = performance.now();
    this.createMesh(geometry, texture);
    this.onResize();
    let endTime = performance.now();
    // console.log(`Initialization and Mesh creation took ${endTime - startTime} milliseconds.`);
    window.addEventListener("resize", () => this.onResize(), false);
  }

  createMesh(geometry, texture) {
    let startTime = performance.now();
    this.material = new THREE.RawShaderMaterial(
      MSDFShader({
        map: texture,
        color: 0x000000,
        side: THREE.DoubleSide,
        transparent: true,
        negate: false
      })
    );
    this.mesh = new THREE.Mesh(geometry, this.material);
    this.mesh.position.set(...this.vars.position);
    this.mesh.rotation.set(...this.vars.rotation);
    this.scene.add(this.mesh);
    let endTime = performance.now();
    // console.log(`Mesh creation took ${endTime - startTime} milliseconds.`);
  }

  onResize() {
    // let startTime = performance.now();
    const w = this.canvas.width;
    const h = this.canvas.height;
    this.camera.aspect = w / h;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize(w, h);
    this.camera.position.z = w < 640 ? 250 : this.vars.zoom;
    let endTime = performance.now();
    // console.log(`Resize processing took ${endTime - startTime} milliseconds.`);
  }

  animate() {
    // let renderStart = performance.now();
    requestAnimationFrame(this.animate.bind(this));
    this.render();
    // let renderEnd = performance.now();
    // console.log(`Rendering frame took ${renderEnd - renderStart} milliseconds.`);
  }

  render() {
    this.renderer.render(this.scene, this.camera);
  }
}
